import api from 'service/api'

const trainingPortalAPI = api.create('trainingPortal', false)

const index = async (params = {}) =>
  trainingPortalAPI.get('/certificates', { params })

export default {
  index,
}
